const { expect } = require('chai');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

const tagIdsWithStatus = (tagIds, status = 'delete') =>
  Object.values(tagIds)
    .map((tagId) => Object.values(tagId))
    .flat()
    .map((tagId) => tagId.migratortron)
    .filter((tagId) => tagId.status === status);

describe('Migrate tags and groups', () => {
  describe('preview migrating a tag group by a query', () => {
    const mock = loadRecordedMock('migrate_taggroups_q=Keywords_preview.json');
    const expectedCount = mock.response.existing.migratortron.totalCount;

    it(`should return one tag group for migration`, (done) => {
      migratortronApi.post(
        'migrate/taggroups?q=Keywords',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(expectedCount);

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron['no change']).to.equal(
            expectedCount
          );
          expect(body.groupsToMigrate.groupIds).to.be.an('object');

          expect(
            Object.values(body.groupsToMigrate.groupIds)
          ).to.have.a.lengthOf(expectedCount);

          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'no change'
            )
          ).to.have.a.lengthOf(expectedCount);
          done();
        }
      );
    });
  });

  describe(`preview migrating the project's tag groups`, () => {
    const mock = loadRecordedMock('migrate_taggroups_simple_preview.json');
    const expectedCount = mock.response.groupsToMigrate.migratortron.totalCount;

    it(`should return ${expectedCount} tag groups`, (done) => {
      migratortronApi.post(
        'migrate/taggroups?simple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(1);

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron['create']).to.equal(
            expectedCount
          );
          // Keywords tag group should always say no change
          expect(body.groupsToMigrate.migratortron['no change']).to.equal(1);
          expect(body.groupsToMigrate.groupIds).to.be.an('object');

          expect(
            Object.values(body.groupsToMigrate.groupIds)
          ).to.have.a.lengthOf(expectedCount + 1);

          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'create'
            )
          ).to.have.a.lengthOf(expectedCount);

          // Keywords tag group should always say no change
          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'no change'
            )
          ).to.have.a.lengthOf(1);
          done();
        }
      );
    });
  });

  describe(`migrate the project's tag groups`, () => {
    const mock = loadRecordedMock('migrate_taggroups_commit_simple.json');
    const expectedCount = mock.response.groupsToMigrate.migratortron.totalCount;

    it(`should create ${expectedCount} tag groups`, (done) => {
      migratortronApi.post(
        'migrate/taggroups/commit?simple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.true;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(1);

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron['create']).to.equal(
            expectedCount
          );
          // Keywords tag group should always say no change
          expect(body.groupsToMigrate.migratortron['no change']).to.equal(1);
          expect(body.groupsToMigrate.groupIds).to.be.an('object');

          expect(
            Object.values(body.groupsToMigrate.groupIds)
          ).to.have.a.lengthOf(expectedCount + 1);

          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'create'
            )
          ).to.have.a.lengthOf(expectedCount);

          // Keywords tag group should always say no change
          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'no change'
            )
          ).to.have.a.lengthOf(1);

          expect(body.groupsResult.created).to.equal(expectedCount);
          done();
        }
      );
    });
  });

  describe(`repeat the same migrate the project's tag groups`, () => {
    const mock = loadRecordedMock(
      'migrate_taggroups_commit_simple_repeat.json'
    );
    const expectedCount = mock.response.groupsToMigrate.migratortron.totalCount;
    const existingCount = mock.response.existing.migratortron.totalCount;

    it(`should return ${existingCount} tag groups`, (done) => {
      migratortronApi.post(
        'migrate/taggroups/commit?simple&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.true;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(existingCount);

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron['no change']).to.equal(
            existingCount
          );
          expect(body.groupsToMigrate.groupIds).to.be.an('object');

          expect(
            Object.values(body.groupsToMigrate.groupIds)
          ).to.have.a.lengthOf(existingCount);

          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'create'
            )
          ).to.have.a.lengthOf(expectedCount);

          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'no change'
            )
          ).to.have.a.lengthOf(existingCount);

          expect(body.groupsResult.created).to.equal(expectedCount);
          done();
        }
      );
    });
  });

  describe(`preview migrating tags by a label`, () => {
    const mock = loadRecordedMock('migrate_tags_label=1_preview.json');
    const expectedCount = mock.response.tagsToMigrate.migratortron.totalCount;

    it(`should return ${expectedCount} tags`, (done) => {
      migratortronApi.post(
        'migrate/tags?label=1',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(0);

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron.totalCount).to.equal(0);
          expect(body.groupsToMigrate.migratortron['no change']).to.equal(2);
          expect(body.groupsToMigrate.groupIds).to.be.an('object');

          expect(
            Object.values(body.groupsToMigrate.groupIds)
          ).to.have.a.lengthOf(expectedCount);

          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'no change'
            )
          ).to.have.a.lengthOf(expectedCount);

          expect(body.tagsToMigrate.migratortron).to.be.an('object');
          expect(body.tagsToMigrate.migratortron.totalCount).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.migratortron.create).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.tagIds).to.be.an('object');

          expect(
            tagIdsWithStatus(body.tagsToMigrate.tagIds, 'create')
          ).to.have.a.lengthOf(expectedCount);

          done();
        }
      );
    });
  });

  describe(`migrate tags by a label`, () => {
    const mock = loadRecordedMock('migrate_tags_commit_label=1.json');
    const expectedCount = mock.response.tagsToMigrate.migratortron.totalCount;

    it(`should return ${expectedCount} tags`, (done) => {
      migratortronApi.post(
        'migrate/tags/commit?label=1',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.true;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(0);

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron.totalCount).to.equal(0);
          expect(body.groupsToMigrate.migratortron['no change']).to.equal(2);
          expect(body.groupsToMigrate.groupIds).to.be.an('object');

          expect(
            Object.values(body.groupsToMigrate.groupIds)
          ).to.have.a.lengthOf(expectedCount);

          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'no change'
            )
          ).to.have.a.lengthOf(expectedCount);

          expect(body.tagsToMigrate.migratortron).to.be.an('object');
          expect(body.tagsToMigrate.migratortron.totalCount).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.migratortron.create).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.tagIds).to.be.an('object');

          expect(
            tagIdsWithStatus(body.tagsToMigrate.tagIds, 'create')
          ).to.have.a.lengthOf(expectedCount);

          expect(body.tagsResult.created).to.equal(expectedCount);
          done();
        }
      );
    });
  });

  describe(`repeat the same migrate tags by a label`, () => {
    const mock = loadRecordedMock('migrate_tags_commit_label=1_repeat.json');
    const expectedCount = mock.response.existing.migratortron.totalCount;

    it(`should return ${expectedCount} tags`, (done) => {
      migratortronApi.post(
        'migrate/tags/commit?label=1&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.true;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(expectedCount);

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron.totalCount).to.equal(0);
          expect(body.groupsToMigrate.migratortron['no change']).to.equal(2);
          expect(body.groupsToMigrate.groupIds).to.be.an('object');

          expect(
            Object.values(body.groupsToMigrate.groupIds)
          ).to.have.a.lengthOf(expectedCount);

          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'no change'
            )
          ).to.have.a.lengthOf(expectedCount);

          expect(body.tagsToMigrate.migratortron).to.be.an('object');
          expect(body.tagsToMigrate.migratortron.totalCount).to.equal(0);
          expect(body.tagsToMigrate.migratortron['no change']).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.tagIds).to.be.an('object');

          expect(
            tagIdsWithStatus(body.tagsToMigrate.tagIds, 'no change')
          ).to.have.a.lengthOf(expectedCount);

          expect(body.tagsResult.created).to.equal(0);
          done();
        }
      );
    });
  });

  describe(`preview migrating tags by a groupId`, () => {
    const mock = loadRecordedMock(
      'migrate_tags_groupId=resourcePickersTagGroup_preview.json'
    );
    const expectedCount = mock.response.tagsToMigrate.migratortron.totalCount;

    it(`should return ${expectedCount} tags`, (done) => {
      migratortronApi.post(
        'migrate/tags?groupId=resourcePickersTagGroup',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(2);

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron.totalCount).to.equal(0);
          expect(body.groupsToMigrate.migratortron['no change']).to.equal(1);
          expect(body.groupsToMigrate.groupIds).to.be.an('object');

          expect(
            Object.values(body.groupsToMigrate.groupIds)
          ).to.have.a.lengthOf(1);

          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'no change'
            )
          ).to.have.a.lengthOf(1);

          expect(body.tagsToMigrate.migratortron).to.be.an('object');
          expect(body.tagsToMigrate.migratortron.totalCount).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.migratortron.create).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.migratortron['no change']).to.equal(1);
          expect(body.tagsToMigrate.tagIds).to.be.an('object');

          expect(
            tagIdsWithStatus(body.tagsToMigrate.tagIds, 'create')
          ).to.have.a.lengthOf(expectedCount);

          expect(
            tagIdsWithStatus(body.tagsToMigrate.tagIds, 'no change')
          ).to.have.a.lengthOf(1);

          done();
        }
      );
    });
  });

  describe(`migrate tags by a groupId`, () => {
    const mock = loadRecordedMock(
      'migrate_tags_commit_groupId=resourcePickersTagGroup.json'
    );
    const expectedCount = mock.response.tagsToMigrate.migratortron.totalCount;

    it(`should return ${expectedCount} tags`, (done) => {
      migratortronApi.post(
        'migrate/tags/commit?groupId=resourcePickersTagGroup',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.true;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(2);

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron.totalCount).to.equal(0);
          expect(body.groupsToMigrate.migratortron['no change']).to.equal(1);
          expect(body.groupsToMigrate.groupIds).to.be.an('object');

          expect(
            Object.values(body.groupsToMigrate.groupIds)
          ).to.have.a.lengthOf(1);

          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'no change'
            )
          ).to.have.a.lengthOf(1);

          expect(body.tagsToMigrate.migratortron).to.be.an('object');
          expect(body.tagsToMigrate.migratortron.totalCount).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.migratortron['no change']).to.equal(1);
          expect(body.tagsToMigrate.migratortron.create).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.tagIds).to.be.an('object');

          expect(
            tagIdsWithStatus(body.tagsToMigrate.tagIds, 'no change')
          ).to.have.a.lengthOf(1);
          expect(
            tagIdsWithStatus(body.tagsToMigrate.tagIds, 'create')
          ).to.have.a.lengthOf(expectedCount);

          expect(body.tagsResult.created).to.equal(expectedCount);
          done();
        }
      );
    });
  });

  describe(`repeat the same migrate tags by a groupId`, () => {
    const mock = loadRecordedMock(
      'migrate_tags_commit_groupId=resourcePickersTagGroup_repeat.json'
    );
    // TODO; this value is 4 it should be 3
    const expectedCount = mock.response.tagsToMigrate.migratortron['no change'];

    it(`should return ${expectedCount} tags`, (done) => {
      migratortronApi.post(
        'migrate/tags/commit?groupId=resourcePickersTagGroup&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.true;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(4);

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron.totalCount).to.equal(0);
          expect(body.groupsToMigrate.migratortron['no change']).to.equal(1);
          expect(body.groupsToMigrate.groupIds).to.be.an('object');

          expect(
            Object.values(body.groupsToMigrate.groupIds)
          ).to.have.a.lengthOf(1);

          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'no change'
            )
          ).to.have.a.lengthOf(1);

          expect(body.tagsToMigrate.migratortron).to.be.an('object');
          expect(body.tagsToMigrate.migratortron.totalCount).to.equal(0);
          expect(body.tagsToMigrate.migratortron['no change']).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.tagIds).to.be.an('object');

          expect(
            tagIdsWithStatus(body.tagsToMigrate.tagIds, 'no change')
          ).to.have.a.lengthOf(expectedCount);

          expect(body.tagsResult.created).to.equal(0);
          done();
        }
      );
    });
  });

  describe(`preview migrating tags and groups based on data supplied with input`, () => {
    const mock = loadRecordedMock('migrate_tags_import_preview.json');
    const expectedCount = mock.response.tagsToMigrate.migratortron.totalCount;
    const expectedGroups =
      mock.response.groupsToMigrate.migratortron.totalCount;
    const errorCount = mock.response.errors.length;

    it(`should return ${expectedCount} tags`, (done) => {
      migratortronApi.post(
        'migrate/tags?import',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.an('array').and.have.a.lengthOf(errorCount);

          expect(body.committed).to.be.false;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(4);

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron.totalCount).to.equal(
            expectedGroups
          );
          expect(body.groupsToMigrate.migratortron.create).to.equal(2);
          expect(body.groupsToMigrate.migratortron.update).to.equal(1);
          expect(body.groupsToMigrate.groupIds).to.be.an('object');

          expect(
            Object.values(body.groupsToMigrate.groupIds)
          ).to.have.a.lengthOf(6);

          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'no change'
            )
          ).to.have.a.lengthOf(1);
          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'create'
            )
          ).to.have.a.lengthOf(2);
          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'unknown'
            )
          ).to.have.a.lengthOf(2);

          const groupUpdates = Object.values(
            body.groupsToMigrate.groupIds
          ).filter((groupId) => groupId.migratortron.status === 'update');
          expect(groupUpdates).to.have.a.lengthOf(1);
          expect(groupUpdates[0].migratortron.diff).to.be.a('string');

          expect(body.tagsToMigrate.migratortron).to.be.an('object');
          expect(body.tagsToMigrate.migratortron.totalCount).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.migratortron.create).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.migratortron.create).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.migratortron.error).to.equal(errorCount);
          expect(body.tagsToMigrate.tagIds).to.be.an('object');

          expect(
            tagIdsWithStatus(body.tagsToMigrate.tagIds, 'create')
          ).to.have.a.lengthOf(expectedCount);

          const errorTags = tagIdsWithStatus(
            body.tagsToMigrate.tagIds,
            'error'
          );
          expect(errorTags).to.have.a.lengthOf(errorCount);
          expect(
            errorTags.every(
              (e) => typeof e.error === 'string' && e.error.length > 10
            )
          ).to.be.true;

          done();
        }
      );
    });
  });

  describe(`migrate tags and groups based on data supplied with input`, () => {
    const mock = loadRecordedMock('migrate_tags_commit_import.json');
    const expectedCount = mock.response.tagsToMigrate.migratortron.totalCount;
    const expectedGroups =
      mock.response.groupsToMigrate.migratortron.totalCount;
    const errorCount = mock.response.errors.length;

    it(`should return ${expectedCount} tags`, (done) => {
      migratortronApi.post(
        'migrate/tags/commit?import',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          // expect(body.errors).to.not.exist;
          expect(body.errors).to.be.an('array').and.have.a.lengthOf(errorCount);

          expect(body.committed).to.be.true;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(4);

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron.totalCount).to.equal(
            expectedGroups
          );
          expect(body.groupsToMigrate.migratortron.create).to.equal(2);
          expect(body.groupsToMigrate.migratortron.update).to.equal(1);
          expect(body.groupsToMigrate.groupIds).to.be.an('object');

          expect(
            Object.values(body.groupsToMigrate.groupIds)
          ).to.have.a.lengthOf(6);

          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'no change'
            )
          ).to.have.a.lengthOf(1);
          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'create'
            )
          ).to.have.a.lengthOf(2);
          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'unknown'
            )
          ).to.have.a.lengthOf(2);

          const groupUpdates = Object.values(
            body.groupsToMigrate.groupIds
          ).filter((groupId) => groupId.migratortron.status === 'update');
          expect(groupUpdates).to.have.a.lengthOf(1);
          expect(groupUpdates[0].migratortron.diff).to.be.a('string');

          expect(body.tagsToMigrate.migratortron).to.be.an('object');
          expect(body.tagsToMigrate.migratortron.totalCount).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.migratortron.create).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.migratortron.create).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.migratortron.error).to.equal(errorCount);
          expect(body.tagsToMigrate.tagIds).to.be.an('object');

          expect(
            tagIdsWithStatus(body.tagsToMigrate.tagIds, 'create')
          ).to.have.a.lengthOf(expectedCount);

          const errorTags = tagIdsWithStatus(
            body.tagsToMigrate.tagIds,
            'error'
          );
          expect(errorTags).to.have.a.lengthOf(errorCount);
          expect(
            errorTags.every(
              (e) => typeof e.error === 'string' && e.error.length > 10
            )
          ).to.be.true;

          expect(body.tagsResult.created).to.equal(expectedCount);
          expect(body.tagsResult.errors).to.equal(errorCount);
          expect(body.groupsResult.created).to.equal(2);
          expect(body.groupsResult.updated).to.equal(1);
          expect(body.groupsResult.errors).to.equal(errorCount);
          done();
        }
      );
    });
  });

  describe(`repeat the same migrate tags and groups based on data supplied with input`, () => {
    const mock = loadRecordedMock('migrate_tags_commit_import_repeat.json');
    const expectedCount = mock.response.tagsToMigrate.migratortron['no change'];
    const expectedGroups =
      mock.response.groupsToMigrate.migratortron['no change'];
    const errorCount = mock.response.errors.length;

    it(`should return ${expectedCount} tags`, (done) => {
      migratortronApi.post(
        'migrate/tags/commit?import&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          // expect(body.errors).to.not.exist;
          expect(body.errors).to.be.an('array').and.have.a.lengthOf(errorCount);

          expect(body.committed).to.be.true;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(7);

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron.totalCount).to.equal(0);
          expect(body.groupsToMigrate.migratortron['no change']).to.equal(
            expectedGroups
          );
          expect(body.groupsToMigrate.migratortron.totalCount).to.equal(0);
          expect(body.groupsToMigrate.groupIds).to.be.an('object');

          expect(
            Object.values(body.groupsToMigrate.groupIds)
          ).to.have.a.lengthOf(6);

          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'no change'
            )
          ).to.have.a.lengthOf(4);
          expect(
            Object.values(body.groupsToMigrate.groupIds).filter(
              (groupId) => groupId.migratortron.status === 'unknown'
            )
          ).to.have.a.lengthOf(2);

          expect(body.tagsToMigrate.migratortron).to.be.an('object');
          expect(body.tagsToMigrate.migratortron.totalCount).to.equal(0);
          expect(body.tagsToMigrate.migratortron['no change']).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.migratortron.error).to.equal(errorCount);
          expect(body.tagsToMigrate.tagIds).to.be.an('object');

          expect(
            tagIdsWithStatus(body.tagsToMigrate.tagIds, 'no change')
          ).to.have.a.lengthOf(expectedCount);

          const errorTags = tagIdsWithStatus(
            body.tagsToMigrate.tagIds,
            'error'
          );
          expect(errorTags).to.have.a.lengthOf(errorCount);
          expect(
            errorTags.every(
              (e) => typeof e.error === 'string' && e.error.length > 10
            )
          ).to.be.true;

          expect(body.tagsResult.created).to.equal(0);
          expect(body.tagsResult.errors).to.equal(errorCount);
          expect(body.groupsResult.created).to.equal(0);
          expect(body.groupsResult.updated).to.equal(0);
          expect(body.groupsResult.errors).to.equal(errorCount);
          done();
        }
      );
    });
  });
});
